<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <input v-model="form.full_name" placeholder="Nama Lengkap" required />
    </div>
    <div class="form-group">
      <input type="email" v-model="form.email" placeholder="Email" required />
    </div>
    <div class="form-group">
      <input type="password" v-model="form.password" placeholder="Password" required />
    </div>
    <button type="submit" :disabled="isSubmitting">
      {{ isSubmitting ? 'Memproses...' : submitText }}
    </button>
    <p v-if="error" class="error-message">{{ error }}</p>
    <p v-if="success" class="success-message">{{ success }}</p>
  </form>
</template>

<script setup>
import { reactive, ref } from 'vue';

const props = defineProps(['submitFunction', 'submitText']);
const emit = defineEmits(['success']);

const form = reactive({ full_name: '', email: '', password: '' });

// =======================================================
// DEFINISIKAN VARIABEL YANG HILANG DI SINI
// =======================================================
const isSubmitting = ref(false);
const error = ref(null);
const success = ref(null);
// =======================================================

const handleSubmit = async () => {
  isSubmitting.value = true;
  error.value = null;
  success.value = null;

  try {
    await props.submitFunction(form);
    success.value = "Operasi berhasil!";
    
    // Reset form setelah berhasil
    Object.assign(form, { full_name: '', email: '', password: '' });
    emit('success');

  } catch (err) {
    if (err.response && err.response.data.detail) {
      // Tangani error validasi dari FastAPI
      if (typeof err.response.data.detail === 'string') {
          error.value = `Gagal: ${err.response.data.detail}`;
      } else {
          error.value = "Gagal: Data yang dikirim tidak valid.";
      }
    } else {
      error.value = "Terjadi kesalahan pada server.";
    }
    console.error("Submit form gagal:", err);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
  /* Style untuk form */
  .form-group { margin-bottom: 1rem; }
  input { width: 100%; padding: 0.5rem; }
  .error-message { color: red; }
  .success-message { color: green; }
</style>